(() => {
  const selector = 'img[data-hanfi-deferred-image]';
  let observer;

  const hydrate = (image) => {
    if (!(image instanceof HTMLImageElement) || image.dataset.hanfiImageState) return;

    const source = image.dataset.src;
    const sourceSet = image.dataset.srcset;
    if (!source) return;

    image.dataset.hanfiImageState = 'loading';

    const markReady = () => {
      image.dataset.hanfiImageState = 'ready';
    };
    image.addEventListener('load', markReady, { once: true });
    image.addEventListener('error', markReady, { once: true });
    if (sourceSet) image.srcset = sourceSet;
    image.src = source;
    image.removeAttribute('data-src');
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-hanfi-deferred-image');
  };

  const loadWithin = (root = document) => {
    const images = [];
    if (root.matches?.(selector)) images.push(root);
    images.push(...root.querySelectorAll?.(selector) || []);
    images.forEach(hydrate);
  };

  const observeWithin = (root = document) => {
    const images = [];
    if (root.matches?.(selector)) images.push(root);
    images.push(...root.querySelectorAll?.(selector) || []);

    if (!('IntersectionObserver' in window)) {
      images.forEach(hydrate);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          observer.unobserve(entry.target);
          hydrate(entry.target);
        });
      }, { rootMargin: '500px 320px', threshold: 0.01 });
    }

    images.forEach((image) => observer.observe(image));
  };

  window.HanfiDeferredImages = { hydrate, loadWithin, observeWithin };

  const init = () => observeWithin(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => observeWithin(event.target));
})();
